var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg16 = function Svg16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#16_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.577 3.21a1.25 1.25 0 0 0-.795-1.043L5.416 7.492v6.424h6.779l.104-.008a.58.58 0 0 0 .48-.487v-.002l.92-6a.585.585 0 0 0-.338-.618.6.6 0 0 0-.245-.05H9.333a.75.75 0 0 1-.75-.75V3.332zM2.083 13.332a.583.583 0 0 0 .583.583h1.25V8.083h-1.25a.583.583 0 0 0-.583.583zm8-8.083h3.024a2.084 2.084 0 0 1 2.075 2.396h-.001l-.92 6a2.084 2.084 0 0 1-2.074 1.77h-9.52a2.083 2.083 0 0 1-2.084-2.083V8.666a2.083 2.083 0 0 1 2.083-2.083H4.18L6.648 1.03l.051-.097a.75.75 0 0 1 .634-.349 2.75 2.75 0 0 1 2.75 2.75z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "16_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default Svg16;